module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }

 if (data.range.length) { ;
__p += '\n<div class="col-sm-12 col-md-3 jump-nav-container">\n    <div class="jump-nav">\n        <div class="goto-selector">\n            Jump to <input class="gotoPage" type="number" min="1" max="' +
((__t = ( data.pages )) == null ? '' : __t) +
'" value="' +
((__t = ( data.pageidx )) == null ? '' : __t) +
'" /> of ' +
((__t = ( data.pages )) == null ? '' : __t) +
'\n        </div>\n        <div class="go-button"><a href="#">go</a></div>\n    </div>\n</div>\n<div class="col-sm-12 col-md-6">\n  <nav>\n    <ul class="pagination">\n    ';
 if (data.pageidx !== 1) { ;
__p += '\n      <li class="prenex" value="' +
((__t = ( data.pageidx - 1 )) == null ? '' : __t) +
'"><a href="#"><span aria-hidden="true">&laquo;</span> Prev</a></li>\n    ';
 } else { ;
__p += '\n      <li class="prenex disabled" value="1"><a href="#"><span aria-hidden="true">&laquo;</span> Prev</a></li>\n    ';
 } ;
__p += '\n\n    ';
 data.range.forEach(function(i) { ;
__p += '\n      ';
 if (i === data.pageidx) { ;
__p += '\n        <li value="' +
((__t = ( i )) == null ? '' : __t) +
'" class="active"><a href="#">' +
((__t = ( i )) == null ? '' : __t) +
'</a></li>\n      ';
 } else { ;
__p += '\n        <li value="' +
((__t = ( i )) == null ? '' : __t) +
'"><a href="#">' +
((__t = ( i )) == null ? '' : __t) +
'</a></li>\n      ';
 } ;
__p += '\n    ';
 }); ;
__p += '\n\n    ';
 if (data.pageidx !== data.pages) { ;
__p += '\n      <li class="prenex" value="' +
((__t = ( data.pageidx + 1 )) == null ? '' : __t) +
'"><a href="#">Next <span aria-hidden="true">&raquo;</span></a></li>\n    ';
 } else { ;
__p += '\n      <li class="prenex disabled" value="' +
((__t = ( data.range )) == null ? '' : __t) +
'"><a href="#">Next <span aria-hidden="true">&raquo;</span></a></li>\n    ';
 } ;
__p += '\n\n\n    </ul>\n  </nav>\n</div>\n<div class="col-sm-12 col-md-3 view-nav-container">\n  <div class="view-nav">\n      <div>View <div class="limit-picker pz-dropdown"></div> per page</div>\n  </div>\n</div>\n';
 } ;
__p += '\n';
return __p
}